import React, { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { first, sortBy } from 'lodash';

import { useProductState } from '../store';
import { getLangCountry } from '@/helpers/languages';

import Price from './Price';
import { fetchShippingCountriesList } from '@/fetchers/shipping';
import { useGiftProduct } from '@/hooks/products/use-gift-product';

const WidgetScalapay = dynamic(() => import('@/components/WidgetScalapay'), {
  ssr: false
});

const FeedatyRecap = dynamic(() => import('../Feedaty/FeedatyRecap'), {
  ssr: false
});

const Details = () => {
  const router = useRouter();
  const { product, variation } = useProductState();
  const { lang, country } = getLangCountry(router.query);

  const gift = useGiftProduct(product.selling_code);

  const firstLowestVariationPrice = first(
    sortBy(product.variations, ({ price }) => {
      return Math.min(
        Number.parseFloat(price.sale_price ? price.sale_price : price.price),
        Number.parseFloat(price.price)
      );
    })
  )?.price;

  const price = variation?.price || firstLowestVariationPrice;

  const countries = fetchShippingCountriesList({ lang });
  const currentCountry = countries.find(c => {
    return c['country-code']?.toLowerCase() === country.toLowerCase();
  });

  useEffect(() => {
    const { breadcrumbs, productName, product_type, selling_code } = product;
    const category = breadcrumbs[breadcrumbs.length - 1] || {};
    let discount = 0;
    if (
      variation?.price?.sale_price &&
      variation?.price?.price &&
      Number.parseFloat(variation.price?.price) > 0 &&
      Number.parseFloat(variation.price?.sale_price) > 0
    ) {
      discount =
        Number.parseFloat(variation.price?.price) -
        Number.parseFloat(variation.price?.sale_price);
    }

    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: 'view_item',
      ecommerce: {
        currency: currentCountry?.currency,
        value: variation?.price?.sale_price || variation?.price?.price || 0,
        items: [
          {
            item_id: product_type + '-' + selling_code,
            item_name: productName,
            discount: discount,
            index: 0,
            item_brand: 'Uyn',
            item_category: category.slug,
            item_list_id: 'single_product_page',
            item_list_name: 'Single product page',
            item_variant: variation?.attribute_color,
            price: variation?.price?.sale_price || variation?.price?.price || 0,
            quantity: 1
          }
        ]
      }
    });
  }, [product.selling_code]);

  return (
    <div className="mb-6">
      <FeedatyRecap product={product} lang={lang} />
      <div>
        <h1 className="h3">{product.productName}</h1>
        {product.short_description && (
          <p className="text-body text-gray-700">{product.short_description}</p>
        )}

        {/* BANNER - PROMO ATTIVA - SCEGLI PRODOTTO */}
        {gift?.banner_product &&
          Object.keys(gift.banner_product).includes(lang) && (
            <div className="bg-gray-100 md:flex md:space-y-0 rounded-lg mt-4">
              <div className="flex-1 flex flex-col justify-center px-4 py-4 lg:py-6">
                <div>
                  <div className="bg-black text-white text-xs font-bold uppercase tracking-uyn inline-flex px-2 py-1 rounded-sm mb-3">
                    {gift.banner_product[lang].title}
                  </div>
                </div>
                <p
                  className="text-black h5 mb-1 text-center lg:text-left"
                  dangerouslySetInnerHTML={{
                    __html: gift.banner_product[lang].text
                  }}
                ></p>

                <p
                  className="text-sm text-center lg:text-left"
                  dangerouslySetInnerHTML={{
                    __html: gift.banner_product[lang].disclaimer || ''
                  }}
                ></p>
              </div>
            </div>
          )}
        <div className="flex justify-between items-center mt-3">
          <Price />
        </div>

        <div>
          <WidgetScalapay
            lang={lang}
            amount={
              price?.sale_price
                ? Number.parseFloat(price.sale_price)
                : Number.parseFloat(price?.price ? price.price : '0')
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Details;
